import { useCallback, useEffect, useRef, useState } from "react";
import { useBlocker } from "react-router-dom";

export function useUnsavedChangesBlocker({ isDirty, onSave, onDiscard, onUpdateSchedule }) {
    const [isOpenModalNotifyChange, setIsOpenModalNotifyChange] = useState(false);

    const isSubmittingRef = useRef(false);

    const blocker = useBlocker(
      useCallback(() => isDirty && !isSubmittingRef.current, [isDirty])
    );

    useEffect(() => {
        if (blocker.state === "blocked") {
            setIsOpenModalNotifyChange(true);
        }
    }, [blocker.state]);

    const proceedWithSubmit = () => {
        isSubmittingRef.current = true;
    };

    const cancelSubmit = () => {
        isSubmittingRef.current = false;
    };

    const handleSaveAndLeave = () => {
        try {
            if (onSave) onSave();
        } catch (err) {
            console.error("Save failed:", err);
        }

        setIsOpenModalNotifyChange(false);
        blocker.proceed();
    };

    const handleDiscardAndLeave = () => {
        try {
            if (onDiscard) onDiscard();
        } catch (err) {
            console.error("Discard failed:", err);
        }

        setIsOpenModalNotifyChange(false);
        blocker.proceed();
    };

    const handleUpdateScheduleAndLeave = onUpdateSchedule ? () => {
        try {
            onUpdateSchedule();
        } catch (err) {
            console.error("Update schedule failed:", err);
        }

        setIsOpenModalNotifyChange(false);
        blocker.proceed();
    } : undefined;

    const handleCancelLeave = () => {
        setIsOpenModalNotifyChange(false);
        blocker.reset();
    };

    return {
        isOpenModalNotifyChange,
        setIsOpenModalNotifyChange,
        handleSaveAndLeave,
        handleDiscardAndLeave,
        handleUpdateScheduleAndLeave,
        handleCancelLeave,
        proceedWithSubmit,
        cancelSubmit
    };
}
